import {Supplier} from "../../types/Supplier";
import {useCallback} from "react";
import useMapBoundaryFilter from "../maps/useMapBoundaryFilter";

interface IUseSupplierMapBoundaryFilterOptions {
  unfilteredSuppliers: Supplier[];
  bounds: google.maps.LatLngBounds | undefined | null;
}

/**
 * A hook that filters suppliers based on their location within provided map boundaries.
 * This is a controlled component - the parent manages the bounds state.
 * @param unfilteredSuppliers a list of suppliers to be filtered.
 * @param bounds the map boundaries to filter by (controlled by parent, always defined with default bounds)
 * @returns an object containing the filtered suppliers
 */
const useSupplierMapBoundaryFilter = ({ unfilteredSuppliers, bounds }: IUseSupplierMapBoundaryFilterOptions) => {
  // Memoize bc we pass it as a dependency to map boundary filter
  const getLatLng = useCallback((supplier: Supplier) => {
    const lat = parseFloat(supplier.addressLatitude);
    const lng = parseFloat(supplier.addressLongitude);

    if (isNaN(lat) || isNaN(lng)) {
      return null;
    }

    return { lat, lng };
  }, []);

  const filteredSuppliers = useMapBoundaryFilter(
    unfilteredSuppliers,
    getLatLng,
    bounds,
    true
  );

  return {
    filteredSuppliers
  }
};

export default useSupplierMapBoundaryFilter;